module.exports = __webpack_public_path__ + "static/media/logo.d7e27908.svg";